import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-update-measure-dialog',
  templateUrl: './update-measure-dialog.component.html',
  styleUrls: ['./update-measure-dialog.component.scss']
})
export class UpdateMeasureDialogComponent implements OnInit {
  form: FormGroup = this.formBuilder.group({
    length: [0, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.min(1)]],
    width: [0, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.min(1)]],
    quantity: [0, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.min(1)]],
  });

  constructor(private dialogRef: MatDialogRef<UpdateMeasureDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data: UpdateMeasureDialogData,
              private formBuilder: FormBuilder
  ) {
  }

  ngOnInit() {
  }

  submit() {
    this.dialogRef.close(this.form.value);
  }

  cancel() {
    this.dialogRef.close();
  }
}

export interface UpdateMeasureDialogData {
  measureType: 'PLA_MA_AN' | 'PLA_MA_AB'
}
